import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "30",
      cy: "30",
      r: "29.5",
      fill: "#F5FAFF",
      stroke: "#BBD8FF",
      "stroke-dasharray": "4 4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#4893F4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M35 38.5H25c-3 0-5-1.5-5-5v-7c0-3.5 2-5 5-5h10c3 0 5 1.5 5 5v7c0 3.5-2 5-5 5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#4893F4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "m35 27-3.13 2.5c-1.03.82-2.72.82-3.75 0L25 27"
    }, null, -1)
  ]))]))
}
export default { render: render }